<!--
    校区管理-分校管理-申请分校
    功能：申请分校
-->
<template>
  <div class="apply" v-loading="loading">
    <el-form :rules="rules" ref="form" :model="form" label-width="130px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="校区名称：" prop="name">
            <el-input v-model="form.name" placeholder="请输入校区名称"></el-input>
          </el-form-item>
          <el-form-item label="品牌名称：">
            <el-input v-model="form.brand" placeholder="请输入品牌名称"></el-input>
          </el-form-item>
<!--          <el-form-item label="总校代付：">-->
<!--            <el-radio v-model="form.is_pil" :label="1">开启</el-radio>-->
<!--            <el-radio v-model="form.is_pil" :label="2">关闭</el-radio>-->
<!--          </el-form-item>-->
          <el-form-item label="所属类目：" prop="school_categories">
            <el-select multiple clearable v-model="form.school_categories" placeholder="请选择类目">
              <el-option
                v-for="item in category"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地区：" prop="places">
            <el-cascader
              v-model="places"
              :options="chinaJSON"
              placeholder="请选择所在地区"
              @change="handleChange"/>
            <el-input class="address" v-model="form.street" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="分校长：" prop="user_name">
            <el-input v-model="form.user_name" placeholder="请输入分校长姓名"></el-input>
          </el-form-item>
          <el-form-item label="分校长电话：" prop="user_mobile">
            <el-input :disabled="!!this.id" v-model.trim="form.user_mobile" placeholder="请输入分校长电话" @input="val => form.user_mobile = val.replace(/[^\d]/g, '').slice(0, 11)"></el-input>
          </el-form-item>
          <el-form-item label="邮箱：">
            <el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="logo：" class="logo">
            <AppUploadScale
              v-model="form.logo"
              :common="true"
              class="form_img"
              @on-success="getThumbnailrUrl" />
          </el-form-item>
<!--          <el-form-item label="公司全称：" class="company">-->
<!--            <el-input v-model="form.company_name" :disabled="this.id" placeholder="请输入公司全称"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="统一社会代码：" class="company">-->
<!--            <el-input v-model="form.company_code" :disabled="this.id" placeholder="请输入统一社会代码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="营业执照上传：">-->
<!--            <img v-if="this.id" class="form_img" :src="form.company_license_img" alt="">-->
<!--            <AppUploadScale-->
<!--              v-else-->
<!--              v-model="form.company_license_img"-->
<!--              :common="true"-->
<!--              class="form_img"-->
<!--              @on-success="getThumbnailrUrlCompany" />-->
<!--          </el-form-item>-->
          <div class="tips" v-if="!id">
            <div class="left">温馨提醒：</div>
            <div class="right">
              <p>审核通过后</p>
              <p>分校长使用手机号登录管理后台，创建对应员工。</p>
              <p>初始密码：a123456</p>
              <p>初始密码较为简单，分校长需登录后台修改密码哦！</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </el-form>
  </div>
</template>

<script>
  import baseUrl from "../../utils/api";
  export default {
    name: "BranchSchoolApply",
    data() {
      return {
        id: this.$route.params.id,
        loading: false,
        places: [],
        form: {
          name: '', // 校区名称
          brand: '', // 品牌名称
          is_pil: 2, // 总校代付
          school_categories: [], // 所属类目
          province: '', // 所在省
          city: '', // 所在市
          area: '', // 所在区
          street: '', // 所在街道等详细地址
          // user_name: '', // 校长名称
          // user_mobile: '', // 校长电话
          email: '', // 邮箱
          company_name: '', // 公司全称
          company_code: '', // 统一社会信用代码
          company_license_img: '', // 营业执照图片url
          places: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入校区', trigger: 'blur' },
          ],
          brand: [
            { required: true, message: '请输入品牌名称', trigger: 'blur' }
          ],
          school_categories: [
            { required: true, message: '请选择类目' }
          ],
          places: [
            { required: true, message: '请选择地区' }
          ],
          user_name: [
            { required: true, message: '请输入分校长', trigger: 'blur' },
          ],
          user_mobile: [
            this.$rules.required('分校长电话'), { ...this.$rules.mobile }
          ],
          logo: [
            { required: true, message: '请选择上传logo' }
          ],
          company_name: [
            { required: true, message: '请输入公司名称' }
          ],
          company_code: [
            { required: true, message: '请输入社会统一代码' }
          ],
          company_license_img: [
            { required: true, message: '请选择上传营业执照' }
          ]
        },
        chinaJSON: this.$assets.chinaJSON,
        isCreated: true,
      }
    },
    computed: {
      category () {
        return this.$store.state.schoolCategory;
      }
    },
    created() {
      // this.$http.get(`${baseUrl}/api/category-school`)
      //   .then(res => {
      //     this.category = res
      //   });

      if (this.id) {
        this.loading = true;

        this.$http.get(`${baseUrl}/api/clients/${this.id}`)
          .then((res) => {
            this.loading = false;
            if (res.review_last) {
              this.form = res.review_last;
            }
            const province = res.review_last.province && res.review_last.province !== '' ? this.chinaJSON.find(item => item.label === res.review_last.province) : ''; // 所在省
            const city = res.review_last.city && res.review_last.city !== '' && province ? province.children.find(item => item.label === res.review_last.city) : ''; // 所在市
            const area = res.review_last.area && res.review_last.area !== '' && city ? city.children.find(item => item.label ===res.review_last.area) : ''; // 所在区

            if (province && city && area) {
              this.places = [province.value ? province.value : '', city.value ? city.value : '', area.value ? area.value : ''];
              this.form.places = this.places.join(',');
            }
          })
          .catch((err) => {
            this.isCreated = true;
            this.$message.error(err.message);
          });
      }
    },
    methods: {
      // 选择地址
      handleChange(val) {
        const province = val[0] ? this.chinaJSON.find(item => item.value === val[0]) : ''; // 所在省
        const city = val[1] ? province.children.find(item => item.value === val[1]) : ''; // 所在市
        const area = val[2] ? city.children.find(item => item.value === val[2]) : ''; // 所在区

        this.form.province = province.label;
        this.form.city = city.label;
        this.form.area = area.label;

        this.form.places = [province.value, city.value, area.value].join(',');
      },
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.isCreated) {
              // 申请校区
              this.isCreated = false;
              if (this.id) {
                this.$http.put(`${baseUrl}/api/clients/${this.id}`, this.form)
                  .then((res) => {
                    this.$message.success('提交成功！');
                    setTimeout(() => {
                      this.$router.back();
                    }, 2000);
                  })
                  .catch((err) => {
                    this.$message.error(err.message);
                  });
              } else {
                this.$http.post(`${baseUrl}/api/clients`, this.form)
                  .then((res) => {
                    this.isCreated = true;
                    this.$message({
                      message: '申请成功！',
                      type: 'success'
                    });
                    setTimeout(() => {
                      this.$router.back();
                    }, 2000)
                  })
                  .catch((err) => {
                    this.isCreated = true;
                    this.$message.error(err.message);
                  });
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getThumbnailrUrl(url) {
        this.$nextTick(() => {
          this.form.logo = url;
        });
        this.$forceUpdate();
      },
      getThumbnailrUrlCompany(url) {
        this.$nextTick(() => {
          this.form.company_license_img = url;
        });
        this.$forceUpdate();
      }
    }
  }
</script>

<style scoped lang="scss">
  .el-form-item {
    padding-right: 15%;
  }
  .address {
    width: calc(100% - 205px);
  }
  .el-select {
    width: 100%;
  }
  .form_img {
    width: 200px;
    min-height: 100px;
    height: auto;
  }
  .image {
    width: 200px;
    height: auto;
  }
  .logo {
    margin-bottom: 25px;
  }
  .company {
    .el-input {
      /*margin-bottom: 22px;*/
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .tips{
    display: flex;
    font-size: 12px;
    color: red;
    .left {
      flex: 0 0 110px;
      text-align: right;
      line-height: 20px;
    }
    .right {
      p {
        margin: 0;
        line-height: 20px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/BranchSchool/apply.vue